import { ReactElement } from 'react';

import styles from './userProfileBadge.module.scss';

interface UserProfileBadgeViewProps {
  displayName: string,
  onClick?: () => void,
  prependSibling?: ReactElement,
  appendSibling?: ReactElement,
}

const UserProfileBadge = ({
  displayName,
  onClick,
  prependSibling,
  appendSibling,
}: UserProfileBadgeViewProps) => (
  <button
    className={ styles.userProfileButton }
    data-test="userProfileBadge"
    onClick={ onClick }
    type="button"
  >
    { prependSibling }
    <span className={ styles.displayName } data-test="userProfileDisplayName">
      { displayName }
    </span>
    { appendSibling }
  </button>
);

export default UserProfileBadge;
